<template>
  <div id="ManualSet">
    <template v-if="$route.name == 'ClassSetExport'">
      <ots-main-title></ots-main-title>
      <ots-table-group-new
        :selectList="selectList"
        :requestForm="requestForm"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        :batchOperBtn="batchOperBtn"
        @search="search"
        @changeNum="changeSize"
        @changePage="changePage"
      ></ots-table-group-new>
    </template>
    <template v-else>
      <router-view />
    </template>
    <!-- 弹窗 -->
    <ots-custom-dialog :dialog.sync="dialogFlag" title="导出桌贴" width="40%">
      <template v-slot:content>
        <el-button round type="primary" @click="exportClassTable(2)" style="margin-left: 40px;">导出PDF版桌贴</el-button>
        <el-button round type="primary" @click="exportClassTable(1)" style="margin-left: 40px;">导出Excel版桌贴</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import {
  getCurrentSelectPlace,
  getPlanAllSessionByPlan,
  getPlaceSessionClassCountFN,
  exportClassRoom,
  getFileDeskTitleApi
} from "@/http/modules/examSet/planClass";

export default {
  data() { 
    return {
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "考点",
          type: "select",
          requestKey: "placeIds",
          multiple: true,
          label: "name",
          value: "id",
          data: [{ id: "", name: "全部" }],
        },
        {
          title: "考试场次",
          type: "select",
          requestKey: "sessionId",
          label: "name",
          value: "id",
          data: [],
        },
      ],
      tableData: [],
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "考点名称",
          prop: "placeName",
        },
        {
          title: "场次",
          prop: "sessionName",
        },
        {
          title: "考场数",
          prop: "classCount",
        },
      ],

      pagination: {
        total: 0,
      },

      requestForm: {
        planId: "",
        placeIds: [""],
        sessionId: "",
        size: 10,
        page: 1,
      },

      batchOperBtn: [
        {
          title: "导出考场门贴",
          icon: "iconfont icon-daochu",
          click: this.exportClass,
        },
        {
          title: "导出考场桌贴",
          icon: "iconfont icon-daochu",
          click: this.exportClassTableDialog,
        },
      ],
      dialogFlag : false,
    };
  },
  watch: {
    "requestForm.planId": "selectPlaceList",
    "requestForm.placeIds": "placeIdsChange",
  },
  created(){
    this.getConfig();
  },
  mounted() {
    this.initData();
  },
  methods: {
    // 考点切换
    placeIdsChange(newVal, oldVal) {
      if (newVal.length > oldVal.length) {
        if (newVal[newVal.length - 1]) {
          this.requestForm.placeIds.map((e, i) => {
            if (!e) {
              this.requestForm.placeIds.splice(i, 1);
            }
          });
        } else {
          this.requestForm.placeIds = [""];
        }
      }
    },

    // 初始化数据
    initData() {
      getSelectPlanFn().then(({ data }) => {
        if (data) {
          this.$set(this.selectList[0], "data", data);
          this.requestForm.planId = data[0].id;
        }
      });
    },
    getConfig() {
      this.$api.system.getConfigData().then((res) => {
        let configList = res.data.configList;
        configList.forEach((item) => {
          if (item.setName == "needSignTable") {
            if (item.setValue == 1) {
              this.batchOperBtn.push({
                title: "导出签到表",
                icon: "iconfont icon-daochu",
                click: this.exportClassSign,
              });
            }
          }
        });
      });
    },
    // 查考点/场次
    selectPlaceList() {
      let params = {
        planId: this.requestForm.planId,
      };
      getCurrentSelectPlace(params).then(({ data }) => {
        this.requestForm.placeIds = [""];
        if (data) {
          let placeList = [{ id: "", name: "全部" }, ...data];
          this.$set(this.selectList[1], "data", placeList);
        } else {
          let placeList = [{ id: "", name: "全部" }];
          this.$set(this.selectList[1], "data", placeList);
        }
      });
      getPlanAllSessionByPlan(params).then(({ data }) => {
        this.requestForm.sessionId = "";
        let sessionList = [{ id: "", name: "全部" }, ...data];
        this.$set(this.selectList[2], "data", sessionList);
      });
      this.search();
    },
    // 搜索
    search() {
      let params = { ...this.requestForm };
      params.placeIds = params.placeIds.join();
      getPlaceSessionClassCountFN(params).then((res) => {
        if(res.code == 1){
        this.pagination.total = res.data.total;
        this.tableData = res.data.records;
        }
      });
    },
    // 导出考场门贴
    exportClass() {
      let params = {
        planId: this.requestForm.planId,
        placeIds: this.requestForm.placeIds,
        sessionId: this.requestForm.sessionId,
        typeId: 1,
      };
      params.placeIds = params.placeIds.join();
      exportClassRoom(params).then((res) => {
        if (res.code == 1) {
          window.open(res.data);
        }
      });
    },

    /**
     * @param { 导出考场桌贴 }
     */
    exportClassTableDialog(){
      this.dialogFlag = true;
    },
    exportClassTable(val) {
      let params = {
        planId: this.requestForm.planId,
        placeIds: this.requestForm.placeIds,
        fileType: val
      }
      params.placeIds = params.placeIds.join();
      getFileDeskTitleApi(params).then(res=>{
        if (res.code == 1) {
          window.open(res.data)
        }
      })
      this.dialogFlag = false;
      return;
      params = {
        planId: this.requestForm.planId,
        placeIds: this.requestForm.placeIds,
        sessionId: this.requestForm.sessionId,
        typeId: 2,
      };
      params.placeIds = params.placeIds.join();
      exportClassRoom(params).then((res) => {
        if (res.code == 1) {
          window.open(res.data);
        }
      });
    },

    // 导出签到表
    exportClassSign() {
      this.$router.push({
        name: "signTable",
        query: {
          planId: this.requestForm.planId,
        },
      });
    },
    changeSize(num) {
      this.requestForm.size = num;
      this.search();
    },
    changePage(p) {
      this.requestForm.page = p;
      this.search();
    },
  },
};
</script>

<style lang="less" scoped></style>
